import { highlightMatches } from '@/utils/escapeHtml.util';

// Used with v-html, so the text and query are escaped before the highlight markup is added.
export default function (word, query) {
  return highlightMatches(word, query, '<span class="matched-text">', '</span>');
}
